import React from 'react';
import { CHART_LEGEND_DEFAULT_COLORS } from '../../consts';
import * as S from './AnalyticsChartLegend.styled';
export const AnalyticsChartLegend = ({ items, showLines = true }) => {
    return (React.createElement(S.Container, null, items.map((item, index) => (React.createElement(S.Item, { key: index },
        showLines && React.createElement(S.Line, { color: item.color || CHART_LEGEND_DEFAULT_COLORS[index] }),
        React.createElement(S.Text, null, item.value))))));
};
